import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';
import { LOCALES } from 'state/intl/types';

import { CaloriesSuffix, IUseFormatCalories } from './types';

const fastFormatNumber = (num: number, locale: string): string => {
  const str = num.toString();
  const len = str.length;

  const SEPARATOR = locale === LOCALES.fr_ca ? ' ' : ',';

  if (len <= 3) {
    return str;
  }
  if (len <= 6) {
    return `${str.slice(0, len - 3)}${SEPARATOR}${str.slice(len - 3)}`;
  }
  if (len <= 9) {
    return `${str.slice(0, len - 6)}${SEPARATOR}${str.slice(
      len - 6,
      len - 3
    )}${SEPARATOR}${str.slice(len - 3)}`;
  }
  //fallback that wont happen unless cals get crazy
  return num.toLocaleString(locale);
};

export function useFormatCalories(): IUseFormatCalories {
  const { locale } = useLocale();

  return function formatCalories(calories: number | null, suffix: CaloriesSuffix = 'Cal'): string {
    const calsString = suffix !== 'none' ? t(suffix.toLowerCase() as any) : '';

    if ((!calories && calories !== 0) || isNaN(calories)) {
      return '';
    }
    const calorieDisplay = fastFormatNumber(Math.floor(calories), locale);

    return `${calorieDisplay} ${calsString}`.trim();
  };
}
